import { Box, Container, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import Searchbar from "../components/Searchbar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CityCard from "../components/Cards/CityCard";
import LoadMoreButton from "../components/LoadMoreButton";
import usePaginatedCities from "../hooks/usePaginatedCities";

function ExploreCityPage() {
  const { t } = useTranslation();
  const [searchQuery, setSearchQuery] = useState("");
  const currentLanguage = localStorage.getItem("language");

  const { 
    cities: filteredCity, 
    loading, 
    loadingMore, 
    hasNextPage, 
    totalLoaded,
    loadMore 
  } = usePaginatedCities(searchQuery, 10);

  const navigate = useNavigate();
  const goBackHome = () => {
    navigate(-1);
  };

  const handleSearchChange = async (city) => {
    setSearchQuery(city);
  };

  // handle loading state for initial load
  if (loading && filteredCity.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "white",
          color: "black",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
          overflow: "hidden",
        }}
      >
        <h1>{t("Loading")}...</h1>
      </div>
    );
  }

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: "10px", sm: "30px", md: "50px" },
        alignItems: "center",
        paddingBottom: "50px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          padding: "20px 0px",
        }}
      >
        {/* <ExplorePageHeader /> */}
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            gutterBottom
            alignSelf={"start"}
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
            }}
          >
            <IconButton aria-label="back" onClick={goBackHome}>
              {currentLanguage === "en" ? (
                <ChevronLeftIcon
                  sx={{
                    fontSize: "35px",
                    color: "black",
                    cursor: "pointer",
                  }}
                />
              ) : (
                <ChevronRightIcon
                  sx={{
                    fontSize: "35px",
                    color: "black",
                    cursor: "pointer",
                  }}
                />
              )}
            </IconButton>
            {t("Cities")}
          </Typography>
        </Box>
        {/* search bar */}
        <Box
          sx={{
            width: "100%",
          }}
        >
          <Searchbar onSearch={handleSearchChange} searchType="city" />
        </Box>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(2,1fr)",
          gap: { xs: 2, sm: 3, md: 5 },
        }}
      >
        {filteredCity.map((city) => (
          <CityCard key={city.id} title={city.city_name} name={city.name} />
        ))}
      </Box>

      {/* Load More Button */}
      {filteredCity.length > 0 && (
        <LoadMoreButton
          onLoadMore={loadMore}
          loading={loadingMore}
          hasMore={hasNextPage}
          totalLoaded={totalLoaded}
        />
      )}
    </Container>
  );
}

export default ExploreCityPage;
